import { ArrowUpRight } from "lucide-react";

export default function TradeConversionBlock({ onEnquiry }) {
  return (
    <section data-testid="trade-with-ugi-conversion-block" className="relative overflow-hidden bg-[#1C1613] text-[#FDFBF7]">
      <div className="absolute inset-0 opacity-[0.08] map-grid-dark" aria-hidden="true" />
      <svg className="absolute inset-0 h-full w-full opacity-30" viewBox="0 0 1440 620" fill="none" preserveAspectRatio="none" aria-hidden="true">
        <path d="M-40 438C195 280 350 247 525 301C736 366 849 347 1041 225C1195 127 1307 113 1480 154" stroke="#C5A059" strokeOpacity="0.52" strokeWidth="1.5" strokeDasharray="8 10" />
        <path d="M-80 510C182 432 379 442 582 487C802 535 994 477 1198 350C1310 281 1390 250 1520 252" stroke="#C5A059" strokeOpacity="0.24" strokeWidth="1" />
        <circle cx="525" cy="301" r="4" fill="#C5A059" />
        <circle cx="1041" cy="225" r="4" fill="#C5A059" />
      </svg>

      <div className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
        <div className="max-w-4xl">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#C5A059]">Trade With UGI</p>
          <h2 data-testid="conversion-block-heading" className="mt-7 font-serif text-4xl font-normal leading-[1.06] tracking-[-0.03em] text-[#FDFBF7] sm:text-5xl lg:text-6xl">
            Looking to source from India? Looking to reach new markets?
          </h2>
          <p data-testid="conversion-block-copy" className="mt-7 max-w-2xl text-base font-light leading-8 text-[#D8D0C3] sm:text-lg">
            Tell UGI what you're looking for and let's explore the opportunity.
          </p>
        </div>
        <div className="mt-12 flex flex-col gap-4 sm:flex-row">
          <button data-testid="trade-with-ugi-main-cta" onClick={onEnquiry} className="group inline-flex items-center justify-center gap-3 bg-[#C5A059] px-8 py-5 text-xs font-bold tracking-[0.18em] text-[#1C1613] transition-colors hover:bg-[#D4AF37] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FDFBF7]">
            TRADE WITH UGI
            <ArrowUpRight size={17} strokeWidth={1.7} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </button>
          <a data-testid="contact-ugi-secondary-cta" href="#contact" className="inline-flex items-center justify-center border border-[#FDFBF7]/30 px-8 py-5 text-xs font-bold tracking-[0.18em] text-[#FDFBF7] transition-colors hover:border-[#C5A059] hover:text-[#C5A059] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A059]">
            CONTACT UGI
          </a>
        </div>
      </div>
    </section>
  );
}
